import { render, staticRenderFns } from "./note-segment.vue?vue&type=template&id=fefd5774&scoped=true&"
import script from "./note-segment.vue?vue&type=script&lang=js&"
export * from "./note-segment.vue?vue&type=script&lang=js&"
import style0 from "./note-segment.vue?vue&type=style&index=0&id=fefd5774&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefd5774",
  null
  
)

export default component.exports